const n = `<svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M104.98 49.11H98.8899C90.7799 49.11 84.1499 55.74 84.1499 63.85V88.04C84.1499 95.16 89.2699 101.14 96.0099 102.49V117.78C96.0099 119.39 97.3099 120.69 98.9199 120.69H104.95C106.56 120.69 107.86 119.39 107.86 117.78V102.49C114.6 101.14 119.72 95.16 119.72 88.04V63.85C119.72 55.74 113.09 49.11 104.98 49.11Z"
    />
    <path
      d="M65.79 7H17.09C12.0697 7 8 11.0697 8 16.09V111.6C8 116.62 12.0697 120.69 17.09 120.69H65.79C70.8103 120.69 74.88 116.62 74.88 111.6V16.09C74.88 11.0697 70.8103 7 65.79 7Z"
    />
    <path
      d="M74.88 23.49H8V38.58H74.88V23.49Z"
      fill="#CB80DE"
    />
    <path
      d="M74.88 55.49H8V70.58H74.88V55.49Z"
      fill="#CB80DE"
    />
    <path
      d="M61.6799 92.72V120.69H35.1699V92.66C35.1699 89.36 37.8499 86.69 41.1399 86.69H55.6399C58.9699 86.69 61.6799 89.39 61.6799 92.73V92.72Z"
      fill="#CB80DE"
    />
</svg>
`;
export {
  n as default
};
//# sourceMappingURL=company-electricity-BIhoqCP9.js.map
